import { Linked } from "@type-r/models";
import { useLinked } from "@type-r/react";
import {
  CompactTextArea,
  PopupIODialog
} from "lqx-react";
import * as React from "react";
import { OrderModel } from "api";
import { ModelDiff, CollectionDiff, DiffsTable } from "common";

export const ResetPODialog = ({ $isOpen, order }) => (
  <PopupIODialog
    $isOpen={$isOpen}
    title="Reset Purchase Order"
    actionLabel="Reset"
    success="Purchase order was reset"
    doIO={async () => {
      await order.doReset();
      await order.fetch();
    }}
  >
    Are you sure to reset this purchase order?
  </PopupIODialog>
);

export const ValidatePODialog = ({
  $isOpen,
  order,
  fetchedOrder
}: {
  $isOpen: Linked<boolean>;
  order: OrderModel;
  fetchedOrder: OrderModel;
}) => {
  const $comment = useLinked("");

  return (
    <PopupIODialog
      title="Validate PO"
      actionLabel="Validate"
      success="Purchase order is validated"
      $isOpen={$isOpen}
      doIO={async () => {
        const isValidation = order.status === "PO Complete" ? false : true;
        await order.doValidatePO({ commentOnSave: $comment.value, isValidation });
        await order.fetch();
      }}
    >
      <CompactTextArea autoFocus label="Comment" rows={10} $value={$comment} />

      <ShowOrdersDiff order={order} fetchedOrder={fetchedOrder} />
    </PopupIODialog>
  );
};

export const ShowOrdersDiff = ({
  order,
  fetchedOrder
}: {
  order: OrderModel;
  fetchedOrder: OrderModel;
}) => (
  <DiffsTable>
    <ModelDiff
      label="Shipping"
      fetched={fetchedOrder.shipping}
      current={order.shipping}
    />
    <ModelDiff
      label="Ship To"
      fetched={fetchedOrder.ship_to}
      current={order.ship_to}
    />
    <ModelDiff
      label="Bill To"
      fetched={fetchedOrder.bill_to}
      current={order.bill_to}
    />
    <ModelDiff
      label="End Customer"
      fetched={fetchedOrder.end_customer}
      current={order.end_customer}
    />
    <CollectionDiff
      fetched={fetchedOrder.parts}
      current={order.parts}
      titleAttr="partNumber"
    />
  </DiffsTable>
);
